"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.reducer = exports.actionCreators = void 0;
exports.actionCreators = {
    requestFlag: function (message) { return function (dispatch, getState) {
        var appState = getState();
        if (appState && appState.flagReport && appState.clientList && appState.clientList.connectedClient) {
            var requestBody = JSON.stringify({
                reportMessage: message
            });
            fetch("/api/report/" + appState.clientList.connectedClient.sessionGuid + "/", {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: requestBody
            })
                .then(function (response) { return dispatch({ type: 'FINISHED_REQUESTING_FLAG' }); });
            dispatch({ type: 'REQUEST_FLAG', message: message });
        }
    }; }
};
var unloadedState = { flagged: false, requestingFlag: false };
exports.reducer = function (state, incomingAction) {
    if (state === undefined) {
        return unloadedState;
    }
    var action = incomingAction;
    switch (action.type) {
        case 'REQUEST_FLAG':
            return {
                requestingFlag: true,
                flagged: state.flagged
            };
        case 'FINISHED_REQUESTING_FLAG':
            return {
                requestingFlag: false,
                flagged: true
            };
        default:
            return state;
    }
};
//# sourceMappingURL=FlagReport.js.map